export const count = (filteredRows, userTable) => {
    if (!filteredRows) { return userTable.length }
    else { return filteredRows.length }
}  
export default count